<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpPanel
    collapsible
  >
    <template
      slot="caption"
    >
      <h5>
        <span>
          Files
        </span>
        <ItpBadge
          :text="'(' + (item.files && item.files.length || 0) + ')'"
          variant="light"
        >
        </ItpBadge>
      </h5>
    </template>
    <ul
      v-if="item.files && item.files.length"
    >
      <li
        :key="file.file_name"
        v-for="file in item.files"
      >
        <ItpLink
          :text="file.file_name"
          :href="file.href"
          target="_blank"
          :downloadFileName="file.file_name"
          use-auth
        >
        </ItpLink>
      </li>
    </ul>
  </ItpPanel>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobFiles extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7726: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7725: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7726 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7725 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7726,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7725],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7726,
      evh_7315092382398562_reload_7725,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("JobFiles", JobFiles);

</script>